var _path, _path2, _path3, _path4, _circle, _ellipse, _circle2, _path5, _circle3, _g, _path6, _circle4, _ellipse2, _ellipse3, _path7, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPretend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.204,
    height: 40.479,
    viewBox: "0 0 43.204 40.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.832,37.384a19.354,19.354,0,0,1-7.652,11.631,4.246,4.246,0,0,1-3.714.6C11.076,48.269.93,43.293,1,26.109a1.416,1.416,0,0,1,1.854-1.338,22.877,22.877,0,0,0,10.641.871,21.817,21.817,0,0,0,4.941-1.422,20.116,20.116,0,0,0,1.22,4.355,6.036,6.036,0,0,0-2.941,3.707c2.606.92,4.216.885,5.213.39a19.1,19.1,0,0,0,4.906,4.711Z",
    transform: "translate(-0.999 -9.433)",
    fill: "#74bfe9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.362,41.7A23.068,23.068,0,0,1,7.056,25.929a23.2,23.2,0,0,1-4.2-.95A1.416,1.416,0,0,0,1,26.317C.93,43.5,11.076,48.477,15.467,49.822a4.246,4.246,0,0,0,3.714-.6,19.009,19.009,0,0,0,2.033-1.679C16.7,48.119,11.888,45.486,9.362,41.7Z",
    transform: "translate(-0.999 -9.641)",
    fill: "#0593ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.878,18.216a29.268,29.268,0,0,1,.794-12.223,2.093,2.093,0,0,1,3.108-1.275,22.816,22.816,0,0,0,9.31,3.233,22.912,22.912,0,0,0,9.791-1.108,2.088,2.088,0,0,1,2.746,1.923c.509,16.418-9.1,21.7-13.331,23.233a4.233,4.233,0,0,1-3.721-.418c-.1-.063-.2-.125-.3-.2a19.1,19.1,0,0,1-4.906-4.711,18.886,18.886,0,0,1-2.272-4.1,20.116,20.116,0,0,1-1.22-4.355Z",
    transform: "translate(-8.442 -3.428)",
    fill: "#74bfe9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.136,8.306a3.488,3.488,0,0,1,1.887-1.554,23.544,23.544,0,0,1-4.243-2.035,2.093,2.093,0,0,0-3.108,1.275,29.268,29.268,0,0,0-.794,12.223,20.116,20.116,0,0,0,1.22,4.355,18.886,18.886,0,0,0,2.272,4.1,19.1,19.1,0,0,0,4.906,4.711c.1.077.2.139.3.2A4.233,4.233,0,0,0,38.3,32c.091-.033.187-.07.282-.106C31.25,26.836,27.752,16.448,32.136,8.306Z",
    transform: "translate(-8.442 -3.428)",
    fill: "#0593ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.549,
    cy: 1.549,
    r: 1.549,
    transform: "translate(37.415 32.51)",
    fill: "#74bfe9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.992,
    cy: 2.213,
    rx: 1.992,
    ry: 2.213,
    transform: "translate(32.103 36.052)",
    fill: "#176eb5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.328,
    cy: 1.328,
    r: 1.328,
    transform: "translate(10.522 2.075)",
    fill: "#176eb5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.547,7.814,6.882,8.922,5.774,10.587,4.666,8.922,3,7.814,4.666,6.705,5.774,5.04,6.882,6.705Z",
    transform: "translate(-1.606 -3.618)",
    fill: "#74bfe9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.213,
    cy: 2.213,
    r: 2.213,
    transform: "translate(6.095 6.945)",
    fill: "#176eb5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.091 7.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87,33.963c4.551-2.885,7.436,1.666,7.436,1.666-7,5.429-7.436-1.666-7.436-1.666Z",
    transform: "translate(-6.87 -19.523)",
    fill: "#edf0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.763,34.568c-1,.495-2.606.53-5.213-.39a6.036,6.036,0,0,1,2.941-3.707A18.886,18.886,0,0,0,28.763,34.568Z",
    transform: "translate(-11.926 -18.754)",
    fill: "#edf0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.371,47.143a31.22,31.22,0,0,0-6.4.321A31.151,31.151,0,0,0,13.8,49.178s2-5.345,5.491-5.909S26.371,47.143,26.371,47.143Z",
    transform: "translate(-8.971 -22.619)",
    fill: "#edf0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.862,17.548c-8.2,3.359-6.718-3.6-6.718-3.6C36.3,12.391,37.862,17.548,37.862,17.548Z",
    transform: "translate(-14.197 -13.658)",
    fill: "#edf0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,18.681s2.655-4.69,7.345-2.035C54.225,16.646,54.141,23.754,46.88,18.681Z",
    transform: "translate(-18.999 -14.317)",
    fill: "#edf0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7,29.024a36.354,36.354,0,0,0,7.108.077s-4.063,4.53-7.575,4.139-6.488-5.7-6.488-5.7A36.8,36.8,0,0,0,39.7,29.024Z",
    transform: "translate(-14.715 -17.866)",
    fill: "#edf0f4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,4.394a.7.7,0,1,0-.7-.7A.7.7,0,0,0,11.7,4.394Z",
    transform: "translate(-4.031 -3)",
    fill: "#0593ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.664,
    cy: 0.664,
    r: 0.664,
    transform: "translate(12.735 6.945)",
    fill: "#0593ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.664,
    cy: 0.885,
    rx: 0.664,
    ry: 0.885,
    transform: "translate(2.111 9.601)",
    fill: "#0593ff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.664,
    cy: 0.885,
    rx: 0.664,
    ry: 0.885,
    transform: "translate(35.645 27.64)",
    fill: "#0593ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.394,49.7a.7.7,0,1,0-.7.7A.7.7,0,0,0,50.394,49.7Z",
    transform: "translate(-15.55 -16.944)",
    fill: "#74bfe9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.664,
    cy: 0.664,
    r: 0.664,
    transform: "translate(39.186 38.265)",
    fill: "#0593ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPretend);
export default __webpack_public_path__ + "static/media/pretend.f1e2c65922096297961b1bc8e5cb82b3.svg";
export { ForwardRef as ReactComponent };